import { createContext, useContext, useState, useCallback } from "react";

const WorkspaceContext = createContext(null);

export const WORKSPACES = {
  cabinet: { id: "cabinet", name: "Cabinet Depot", tagline: "Ops Console", home: "/" },
  appliance: { id: "appliance", name: "Appliance Depot", tagline: "Documents Console", home: "/appliance" },
};

export function WorkspaceProvider({ children }) {
  const [workspace, setWorkspaceState] = useState(
    () => localStorage.getItem("cd_workspace") || "cabinet",
  );

  const setWorkspace = useCallback((id) => {
    if (!WORKSPACES[id]) return;
    localStorage.setItem("cd_workspace", id);
    setWorkspaceState(id);
  }, []);

  return (
    <WorkspaceContext.Provider value={{ workspace, setWorkspace, meta: WORKSPACES[workspace] }}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export function useWorkspace() {
  const ctx = useContext(WorkspaceContext);
  if (!ctx) throw new Error("useWorkspace must be used within WorkspaceProvider");
  return ctx;
}
